export default "__VITE_ASSET__7a6d30f4__"